import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const SocialLinks = ({type,color}) => {
  const data = useStaticQuery(graphql`
  query{
    instagram: file(relativePath: { eq: "Zoom_Social-Instagram.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    linkedin: file(relativePath: { eq: "Zoom_Social-LinkedIn.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    twitter: file(relativePath: { eq: "Zoom_Social-Twitter.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    instagram_w: file(relativePath: { eq: "Zoom_Social-Instagram_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    linkedin_w: file(relativePath: { eq: "Zoom_Social-LinkedIn_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    twitter_w: file(relativePath: { eq: "Zoom_Social-Twitter_w.png" }) {
        childImageSharp {
          fluid(maxWidth: 500) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
  }
  `)

  const social_url = {
    instagram:"https://www.instagram.com/zoomhr.inc/",
    linkedin:"https://www.linkedin.com/company/40805864",
    twitter:"https://twitter.com/zoom_hr"
  }

  console.log(`color: ${color}`)
  console.log(`type: ${type}`)

  return (<ul className={`social-links`}>
    {`linkedin,instagram,twitter`.split(`,`).map((channel, i) => {
      console.log('data imageSharp');
      console.log(data[channel+color]);
      //
      return(
      <li key={`${type}-social-${i}`}><a href={social_url[channel]} target={`_blank`}><Img fluid={data[channel+(color || '')].childImageSharp.fluid}/></a></li>
    )}
    )}
  </ul>)
}




export default SocialLinks
